import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=33d58d30&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"

import "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=33d58d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d58d30"]])

export default __exports__